import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { request } from "@/js/http/http_request";
import { regExpPassword } from "@/js/regexp_validation.js";
export default {
  name: "actionReset",
  data: function data() {
    return {
      isReseting: false,
      keyReset: "",
      passwordError: "",
      checkPasswordError: "",
      telCheckError: "",
      resetDone: false,
      serverError: false,
      alreadyUsedCode: false,
      telCheck: false,
      isShowPassword: false,
      input: {
        password: "",
        checkPassword: "",
        telCheckCode: "",
        serverTelCheckCode: ""
      },
      errorMessages: {
        password: {
          empty: "This field is required",
          format: "Your password must be at least 8 characters, with at least a number, an upper and lower case letter",
          different: "Password do not match"
        },
        check: {
          empty: "Please enter the code received by SMS.",
          different: "Wrong code."
        }
      }
    };
  },
  created: function created() {
    var _this = this;
    _this.keyReset = this.$route.params.key;
    var data = {
      keyReset: _this.keyReset,
      password: "",
      client_id: _this.$whitelabel.clientId,
      client_secret: _this.$whitelabel.clientSecret
    };
    request("/v1/account/check-reset-link", "post", data, false, "api").catch(function (e) {
      if (e.response.status == 401) {
        _this.alreadyUsedCode = true;
      } else {
        _this.serverError = true;
      }
    });
  },
  methods: {
    reset: function reset() {
      if (this.validateDatas(true)) {
        var _this = this;
        var data = {
          keyReset: _this.keyReset,
          password: _this.input.password,
          client_id: _this.$whitelabel.clientId,
          client_secret: _this.$whitelabel.clientSecret
        };
        _this.isReseting = true;
        request("/v1/account/reset-password", "post", data, false, "api").then(function (response) {
          _this.isReseting = false;
          _this.resetDone = true;
          if (response.status != 200) {
            _this.serverError = true;
          }
        }).catch(function (err) {
          _this.isReseting = false;
          _this.resetDone = true;
          if (err.response.status == 401) {
            _this.alreadyUsedCode = true;
          } else {
            _this.serverError = true;
          }
        });
      }
    },
    validateDatas: function validateDatas(doValidateCheckCode) {
      this.checkPasswordError = "";
      this.passwordError = "";
      if (doValidateCheckCode == true) {
        this.telCheckError = "";
        if (this.input.telCheckCode == "") {
          this.telCheckError = this.errorMessages.check.empty;
        } else if (this.input.telCheckCode != this.serverTelCheckCode) {
          this.telCheckError = this.errorMessages.check.different;
        }
      }
      if (!this.input.password) {
        this.passwordError = this.errorMessages.password.empty;
      } else if (!regExpPassword.test(this.input.password)) {
        this.passwordError = this.errorMessages.password.format;
      }
      if (this.input.password != this.input.checkPassword) {
        this.checkPasswordError = this.errorMessages.password.different;
      }
      if (this.passwordError != "" || this.checkPasswordError != "") {
        return false;
      }
      return true;
    },
    sendTelCheck: function sendTelCheck() {
      if (process.env.VUE_APP_SMS_ACTIVE === "true") {
        if (this.validateDatas(false)) {
          var _this = this;
          var data = {
            keyReset: _this.keyReset
          };
          request("/v1/account/reset-password/tel-check", "post", data, false, "api").then(function (response) {
            if (response.data.keyReset != _this.keyReset) {
              _this.serverError = true;
            } else {
              _this.telCheck = true;
              _this.serverTelCheckCode = response.data.checkCode;
            }
          }).catch(function (err) {
            _this.serverError = true;
          });
        }
      } else {
        //SMS NOT ACTIVE : WE RESET WITHOUT IT
        this.reset();
      }
    },
    smsCheckActive: function smsCheckActive() {
      return process.env.VUE_APP_SMS_ACTIVE == true;
    },
    resetPassword: function resetPassword() {
      this.$router.push({
        name: "reset"
      });
    },
    login: function login() {
      this.$router.push({
        name: "login"
      });
    },
    home: function home() {
      this.$router.push({
        name: "home"
      });
    }
  }
};